import React from 'react';
import ReactDOM from 'react-dom';
import AccommodationMapApp from "./apps/AccommodationMapApp";

const root = document.querySelector('[data-nezzokontikifrontend-accommodationmap]');

if(root !== null) {

    /*TODO: MW: do wee need this?*/
    //const translationScriptTag = document.querySelector('[data-nezzokontikifrontend-translation]');
    //const translations = JSON.parse(translationScriptTag ? translationScriptTag.innerHTML : '[]');

    const accommodationScriptTag = document.querySelector('[data-nezzokontikifrontend-accommodations]');
    const accommodations = JSON.parse(accommodationScriptTag ? accommodationScriptTag.innerHTML : '[]');
    const openMapLink = Array.from( document.querySelectorAll('[data-nezzokontikifrontend-accommodationmap-openMap]'));

    ReactDOM.render(
        <AccommodationMapApp
            accommodations={accommodations}
            openMapLink={openMapLink}
        />,
        root
    );

}



// WEBPACK FOOTER //
// ./src/accommodationMap.js